import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';


export default function DialogComment(props: any) {

    let {open, setOpen, text} = props

    return (

        <Dialog open={open} onClose={() => setOpen(false)}     //alternative methods: 1) fullWidth={true} maxWidth="xl"  2) fullScreen
                slotProps={{ paper: { sx: {
                            minHeight: '95vh',
                            // maxHeight: '95vh',
                            minWidth: '95vw',
                            // maxWidth: '95vw'
                        }}}}
        >
            <DialogTitle>Mapping Comment</DialogTitle>

            <DialogContent>

                <DialogContentText style={{fontSize: '0.85rem'}}>
                    {text}
                </DialogContentText>

            </DialogContent>

            <DialogActions>
                <Button
                    variant="contained"
                    onClick={() => setOpen(false)}
                    sx={{backgroundColor: "#cc7a00", width: "150px", height: "30px"}}>
                    CLOSE
                </Button>
            </DialogActions>

        </Dialog>
    )
}
